import { IMAGES } from "@/content";

export const About = ({ t }) => (
  <section id="about" className="py-24 md:py-32" data-testid="about-section">
    <div className="max-w-6xl mx-auto px-6 grid md:grid-cols-[.8fr_1.2fr] gap-12">
      <figure className="reveal relative aspect-[3/4] bg-imagebg overflow-hidden">
        <img src={IMAGES.archive} alt="Historic arch framing a minaret in Libya" className="absolute inset-0 w-full h-full object-cover" loading="lazy" />
        <figcaption className="lb absolute bottom-5 start-5 bg-paper/90 px-2 py-1 text-caption">{t.archiveCaption}</figcaption>
      </figure>
      <div className="min-w-0">
        <p className="lb text-brassink">{t.aboutLabel}</p>
        <p className="dd tn mt-6 text-[clamp(64px,9vw,120px)] leading-none latin" dir="ltr" data-testid="milestone-date">24.11.2002</p>
        <p className="dd italic mt-6 text-[clamp(26px,3vw,40px)] leading-[1.15] max-w-xl" data-testid="milestone-headline">{t.milestoneHeadline}</p>
        <p className="dd mt-3 text-[clamp(18px,1.6vw,22px)] leading-[1.4] max-w-xl text-brassink" data-testid="milestone-subline">{t.milestoneSub}</p>
        <div className="mt-8 h-px w-16 bg-brass" aria-hidden="true" />
        <p className="mt-8 text-[18px] leading-[1.6] max-w-lg" data-testid="milestone-text">{t.milestone}</p>
        <p className="mt-4 sv text-[17px] leading-[1.6] max-w-lg text-ink2">{t.milestoneNote}</p>

        <p className="lb text-brassink mt-14">{t.profileLabel}</p>
        <div className="mt-4 space-y-4 sv text-[16px] leading-[1.7] text-ink2 max-w-xl" data-testid="profile-text">
          {t.profile.map((p) => <p key={p.slice(0, 20)}>{p}</p>)}
        </div>

        <p className="lb text-brassink mt-12">{t.focusLabel}</p>
        <ul className="mt-4 flex flex-wrap gap-2" data-testid="focus-list">
          {t.focus.map((f) => (
            <li key={f} className="sv text-sm border border-ink/25 px-3 py-1.5">{f}</li>
          ))}
        </ul>
      </div>
    </div>
  </section>
);
